import { ResumeCard } from '../../../../components/resume-card';
import { Head, ResumeCardType } from '../../../../models/home';

interface ResumeSectionProps {
	data?: Head;
	isLoading?: boolean;
}

const ResumeSection = ({ data, isLoading = false }: ResumeSectionProps) => {
	return (
		<>
			<ResumeCard
				type={ResumeCardType.AMOUNT}
				value={data?.amountCollected?.value}
				icon={data?.amountCollected?.icon}
				resume={data?.amountCollected?.resume}
				prefix="$"
				isLoading={isLoading}
			/>
			<ResumeCard
				type={ResumeCardType.CONVERSION}
				value={data?.convertion?.value}
				icon={data?.convertion?.icon}
				resume={data?.convertion?.resume}
				suffix="%"
				isLoading={isLoading}
			/>
			<ResumeCard
				type={ResumeCardType.SUCCESSFUL}
				value={data?.success?.value}
				icon={data?.success?.icon}
				resume={data?.success?.resume}
				isLoading={isLoading}
			/>
			{data?.successToReview && (
				<ResumeCard
					type={ResumeCardType.PENDING}
					value={data?.successToReview.value}
					icon={data?.successToReview.icon}
					resume={data?.successToReview.resume}
					isLoading={isLoading}
				/>
			)}
		</>
	);
};

export { ResumeSection };
